import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styles from "./ConversationsScreen.module.scss";
import { Link } from "@reach/router";
import { storyNames } from "../../storage/stories";
import characters from "../../characters";
import logo from "../../../images/logo192.png"
import ProfileImage from "../widgets/ProfileImage";
import Message from "../../domain/Message";
import { restartGame } from "../../utils/storage";
import { FaTimes } from "react-icons/fa";
import moment from "moment";
import patreonLogo from "../../../images/patreon-icon.png";

const ConversationRow = ({ conversation }) => {
  const { name, profilePicture } = characters[conversation.storyName];

  return <div className={styles.conversationRow}>
    <ProfileImage src={profilePicture}/>
    <Link className={styles.conversationLink} to={"/chat/" + conversation.storyName}>
      <div className={styles.conversationText}>
        <div className={styles.profileName}>
          {name}
        </div>
        <div className={styles.lastMessage}>
          {conversation.lastMessage.previewText}
        </div>
      </div>
      <div className={styles.timeOfArrival}>
        {new moment(conversation.lastMessage.timeOfArrival).fromNow()}
      </div>
    </Link>
  </div>
};

class ConversationsScreen extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Fragment>
      <div className={styles.header}>
        <a href={"https://patreon.com/fAppteam"}>
          <img src={patreonLogo} className={styles.icon} alt={"Patreon Icon"}/>
        </a>
        <span className={styles.logoContainer}>
          <ProfileImage src={logo} alt={"fApp logo"}/>
        </span>
        <FaTimes className={styles.icon} onClick={restartGame}/>
      </div>

      <div>
        {_.orderBy(this.props.conversations, "lastMessage.timeOfArrival", "desc")
          .map(conversation =>
            <ConversationRow key={conversation.storyName} conversation={conversation}/>)}
      </div>
    </Fragment>;
  }
}

const mapState = (state) => {
  return {
    conversations: _.map(storyNames, name => ({
      lastMessage: new Message(_.last(state[name].receivedMessages)),
      storyName: name
    }))
  };
};

export default connect(mapState)(ConversationsScreen);